import React, { useState } from "react";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { constants } from "../../constants/constants";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { uploadFile } from "../../utils/ApiCalls/Document";
import { addlog } from "../../utils/ApiCalls/Logs";
import {
  createPackageDetails,
  updatePackageData,
} from "../../utils/ApiCalls/Package/index";
import { checkFields } from "../../utils/Validation/checkFields";
import UploadFileImage from "../imageUpload/uploadFileImage";

import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { IMAGE_SUB_TYPE, IMAGE_TYPE } from "../../constants/ImageConstant";
import SwitchBar from "../Pages/SwitchBar";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const PACKAGE_ALT_FIELDS = [
  "itineary_image_alt",
  "itineary_simplified_chinese_image_alt",
  "itineary_traditional_chinese_image_alt",
  "itineary_bahasa_image_alt",
  "thumbnail_image_alt",
  "thumbnail_simplified_chinese_image_alt",
  "thumbnail_traditional_chinese_image_alt",
  "thumbnail_bahasa_image_alt",
];

const PackageInput2 = ({ packages, itinerary_key }) => {
  const [englishTitle, setEnglishTitle] = useState(
    packages.package?.title || ""
  );
  const [active, setActive] = useState(packages.package.itinerary_id?.[0]);

  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState(
    packages.package?.simplified_chinese_title || ""
  );
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState(
    packages.package?.traditional_chinese_title || ""
  );

  const [englishSubTitle, setEnglishSubTitle] = useState(
    packages.package?.sub_title || ""
  );
  const [simplifiedChineseSubTitle, setSimplifiedChineseSubTitle] = useState(
    packages.package?.simplified_chinese_sub_title || ""
  );
  const [traditionalChineseSubTitle, setTraditionalChineseSubTitle] = useState(
    packages.package?.traditional_chinese_sub_title || ""
  );

  const [englishDescription, setEnglishDescription] = useState(
    packages.package?.description || ""
  );
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState(packages.package?.simplified_chinese_description || "");
  const [traditionalChineseDescription, setTraditionalChineseDescription] =
    useState(packages.package?.traditional_chinese_description || "");

  const [englishNote, setEnglishNote] = useState(packages.note?.note || "");
  const [simplifiedChinesNote, setSimplifiedChineseNote] = useState(
    packages.note?.simplified_chinese_note || ""
  );
  const [traditionalChineseNote, setTraditionalChineseNote] = useState(
    packages.note?.traditional_chinese_note || ""
  );

  const [itinearies, setItinearies] = useState(
    packages.itinearies ? packages.itinearies : {}
  );

  const [isActive, setIsActive] = useState(packages.package?.is_active);
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseFile, setTraditionalChineseFile] = useState(null);
  const [simplifiedChineseFile, setSimplifiedChineseFile] = useState(null);

  const [thumbnailTraditionalChineseFile, setThumbnailTraditionalChineseFile] =
    useState(null);
  const [thumbnailSimplifiedChineseFile, setThumbnailSimplifiedChineseFile] =
    useState(null);

  const [thumbailSelectedFile, setThumbailSelectedFile] = useState(null);
  const [itineary_image, setItinearyImage] = useState(
    packages.package?.itineary_image
  );
  const [itineary_simplified_chinese_image, setItinearySimplifiedChineseImage] =
    useState(packages.package?.itineary_simplified_chinese_image);
  const [
    itineary_traditional_chinese_image,
    setItinearyTraditionalChineseImage,
  ] = useState(packages.package?.itineary_traditional_chinese_image);
  const [itineary_bahasa_image, setItinearyBahasaImage] = useState(
    packages.package?.itineary_bahasa_image
  );

  const [thumbnail_image, setThumbnailImage] = useState(
    packages.package?.thumbnail_image
  );
  const [
    thumbnail_simplified_chinese_image,
    setThumbnailSimplifiedChineseImage,
  ] = useState(packages.package?.thumbnail_simplified_chinese_image);
  const [
    thumbnail_traditional_chinese_image,
    setThumbnailTraditionalChineseImage,
  ] = useState(packages.package?.thumbnail_traditional_chinese_image);
  const [thumbnail_bahasa_image, setThumbnailBahasaImage] = useState(
    packages.package?.thumbnail_bahasa_image
  );

  const [bahasaTitle, setBahasaTitle] = useState(packages.package?.bahasa_title || "");
  const [bahasaDescription, setBahasaDescription] = useState(packages.package?.bahasa_description || "");
  const [bahasaNote, setBahasaNote] = useState(packages.note?.bahasa_note || "");
  const [bahasaFile, setBahasaFile] = useState(null);
  const [thumbnailBahasaFile, setThumbnailBahasaFile] = useState(null);
  const [altText, setAltText] = useState(
    pickAltText(packages.package, PACKAGE_ALT_FIELDS)
  );

  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();

  const navigate = useNavigate();

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ direction: "rtl" }],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const updatePackage = async (e) => {
    e.preventDefault();
    let packageDataValues = {
      title: englishTitle,
      traditional_chinese_title: traditionalChineseTitle,
      simplified_chinese_title: simplifiedChineseTitle,
      sub_title: englishSubTitle,
      simplified_chinese_sub_title: simplifiedChineseSubTitle,
      traditional_chinese_sub_title: traditionalChineseSubTitle,

      description: englishDescription,

      itineary_image,
      itineary_simplified_chinese_image,
      itineary_traditional_chinese_image,
      itineary_bahasa_image,
      thumbnail_image,
      thumbnail_simplified_chinese_image,
      thumbnail_traditional_chinese_image,
      thumbnail_bahasa_image,
      simplified_chinese_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescription,
      bahasa_title: bahasaTitle,
      bahasa_description: bahasaDescription,
      bahasa_note: bahasaNote,
      note: englishNote,
      simplified_chinese_note: simplifiedChinesNote,
      traditional_chinese_note: traditionalChineseNote,
      ...altText,
      // is_active: isActive ? 1 : 0,
    };

    let packageValues = {
      is_active: isActive ? 1 : 0,
    };
    let noteDataValues = {
      module: "Packages",
      note: englishNote,
      simplified_chinese_note: simplifiedChinesNote,
      traditional_chinese_note: traditionalChineseNote,
      bahasa_note: bahasaNote,
    };

    try {
      if (selectedFile) {
        let imageType = {
          type: IMAGE_TYPE.PACKAGE_MAP_IMG,
          subType: IMAGE_SUB_TYPE.ENGLISH_IMG,
        };
        let image = await uploadFile(selectedFile, imageType, undefined, typeof packages?.package?.itineary_image === 'string' ? packages.package.itineary_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);

        const value = image?.url ? image.url : "";
        packageDataValues["itineary_image"] = value;
      }

      if (thumbailSelectedFile) {
        let image = await uploadFile(thumbailSelectedFile, undefined, undefined, typeof packages?.package?.thumbnail_image === 'string' ? packages.package.thumbnail_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        const value = image?.url ? image.url : "";
        packageDataValues["thumbnail_image"] = value;
      }

      if (traditionalChineseFile) {
        let imageType = {
          type: IMAGE_TYPE.PACKAGE_MAP_IMG,
          subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
        };
        let image = await uploadFile(traditionalChineseFile, imageType, undefined, typeof packages?.package?.itineary_traditional_chinese_image === 'string' ? packages.package.itineary_traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);
        packageDataValues.itineary_traditional_chinese_image = image?.url;
      }

      // else {
      //   packageDataValues["itineary_traditional_chinese_image"] = "";
      // }
      if (simplifiedChineseFile) {
        let imageType = {
          type: IMAGE_TYPE.PACKAGE_MAP_IMG,
          subType: IMAGE_SUB_TYPE.SIMPLIFIED_CHINESE_IMG,
        };
        let image = await uploadFile(simplifiedChineseFile, imageType, undefined, typeof packages?.package?.itineary_simplified_chinese_image === 'string' ? packages.package.itineary_simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);
        packageDataValues.itineary_simplified_chinese_image = image?.url;
      }

      if (bahasaFile) {
        let imageType = {
          type: IMAGE_TYPE.PACKAGE_MAP_IMG,
          subType: IMAGE_SUB_TYPE.BAHASA_IMG,
        };
        let image = await uploadFile(bahasaFile, imageType, undefined, typeof packages?.package?.itineary_bahasa_image === 'string' ? packages.package.itineary_bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);
        packageDataValues.itineary_bahasa_image = image?.url;
      }

      if (thumbnailTraditionalChineseFile) {
        let image = await uploadFile(thumbnailTraditionalChineseFile, undefined, undefined, typeof packages?.package?.thumbnail_traditional_chinese_image === 'string' ? packages.package.thumbnail_traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        packageDataValues.thumbnail_traditional_chinese_image = image?.url;
      }

      if (thumbnailSimplifiedChineseFile) {
        let image = await uploadFile(thumbnailSimplifiedChineseFile, undefined, undefined, typeof packages?.package?.thumbnail_simplified_chinese_image === 'string' ? packages.package.thumbnail_simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        packageDataValues.thumbnail_simplified_chinese_image = image?.url;
      }

      if (thumbnailBahasaFile) {
        let image = await uploadFile(thumbnailBahasaFile, undefined, undefined, typeof packages?.package?.thumbnail_bahasa_image === 'string' ? packages.package.thumbnail_bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        packageDataValues.thumbnail_bahasa_image = image?.url;
      }

      let packageValid = checkFields(packageDataValues);

      if (packageValid) {
        let valid = packageValid;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: valid,
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } else {
        try {
          setError();
          let data = await createPackageDetails({
            ...packageDataValues,
            itinerary_key: itinerary_key,
          });
          for (const item of packages.package.itinerary_id) {
            try {
              let itinearyDataValues = itinearies[active].filter((iti) => {
                if (iti.port_name !== "High Seas") {
                  iti.day && delete iti.day;
                  return iti;
                }
              });
              const data = await updatePackageData(item, {
                ...packageValues,
                items: itinearyDataValues,
                noteItem: noteDataValues,
              });

              if (data?.error) {
                throw new Error(data.error);
              }

              if (packages?.id) {
                addlog(
                  "Package Updated",
                  "Package",
                  {
                    id: packages.id,
                    title: packages.package_name,
                  },
                  userDetails.id
                );
              }
            } catch (error) {
              console.error("Error updating package data:", error.message);
            }
          }

          navigate("/website/cms/packages");

          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: "Values updated", type: "success" },
          });
        } catch (error) {

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.message || "Unknown error occurred",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });
    }
  };

  const handleItineary = (e, index, key) => {
    let newData = { ...itinearies };
    const newItinearies = [...newData[active]];

    newItinearies[index][key] = e.target.value;
    setItinearies({ ...newData, active: [...newItinearies] });
  };

  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <form className="input_form" onSubmit={updatePackage}>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Package Information</h3>
              </div>
              <div className="card-body pb-2">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Itinerary Id</label>
                      {packages.package?.itinerary_id &&
                        packages.package.itinerary_id.length > 0 && (
                          <ul className="multiple_dates">
                            {packages.package.itinerary_id.map((c, index) => (
                              <li key={index + ""}>{c}</li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Itravel Itinerary Title</label>
                      <p className="f_data">{packages.package?.package_name}</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Cruise Id (Sailing Dates)
                      </label>
                      {packages.package?.cruises &&
                        packages.package.cruises.length > 0 && (
                          <ul className="multiple_dates">
                            {packages.package.cruises.map((c, index) => (
                              <li key={index + ""}>{c}</li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Departure Port</label>
                      <p className="f_data">
                        {packages.package?.departure_port}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Vessel</label>
                      <p className="f_data">{packages.package?.vessel_name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Package Details</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">English Display Title</label>
                      <input
                        // required
                        className="f_input"
                        onChange={(e) => setEnglishTitle(e.target.value)}
                        value={englishTitle}
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Display Title
                      </label>
                      <input
                        // required
                        className="f_input"
                        onChange={(e) =>
                          setSimplifiedChineseTitle(e.target.value)
                        }
                        value={simplifiedChineseTitle}
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Display Title
                      </label>
                      <input
                        // required
                        className="f_input"
                        onChange={(e) =>
                          setTraditionalChineseTitle(e.target.value)
                        }
                        value={traditionalChineseTitle}
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Display Title</label>
                      <input
                        className="f_input"
                        onChange={(e) => setBahasaTitle(e.target.value)}
                        value={bahasaTitle}
                        type="text"
                      />
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Description</label>
                      <ReactQuill
                        value={englishDescription}
                        onChange={(e) => setEnglishDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Description
                      </label>
                      <ReactQuill
                        value={simplifiedChineseDescription}
                        onChange={(e) => setSimplifiedChineseDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Description
                      </label>
                      <ReactQuill
                        value={traditionalChineseDescription}
                        onChange={(e) => setTraditionalChineseDescription(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Description</label>
                      <ReactQuill
                        value={bahasaDescription}
                        onChange={setBahasaDescription}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <SwitchBar
              tabs={packages.package.itinerary_id.map((item) => ({
                title: item,
                value: item,
              }))}
              activeTab={active}
              setActiveTab={setActive}
            />
            {itinearies[active] && itinearies[active].length > 0 && (
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Itinerary {active}</h3>
                </div>
                <div className="card-body">
                  <div className="add_iti_table">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th>Port</th>
                          <th>Display Port</th>
                          <th>Arrival</th>
                          <th>Display Arrival</th>
                          <th>Departure</th>
                          <th>Display Departure</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itinearies?.[active].map((i, index) => (
                          <tr key={index + ""}>
                            <td>
                              <input
                                type="number"
                                onChange={(e) =>
                                  handleItineary(e, index, "departure_day")
                                }
                                value={i.day}
                                // readOnly
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleItineary(e, index, "port_name")
                                }
                                value={i.port_name}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                readOnly={i.port_name === "High Seas"}
                                onChange={(e) =>
                                  handleItineary(e, index, "display_port_name")
                                }
                                value={i?.display_port_name}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleItineary(e, index, "arrival_time")
                                }
                                value={i?.arrival_time}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                readOnly={i.port_name === "High Seas"}
                                onChange={(e) =>
                                  handleItineary(
                                    e,
                                    index,
                                    "display_arrival_time"
                                  )
                                }
                                value={i?.display_arrival_time}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                onChange={(e) =>
                                  handleItineary(e, index, "departur_time")
                                }
                                value={i?.departur_time}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                readOnly={i.port_name === "High Seas"}
                                onChange={(e) =>
                                  handleItineary(
                                    e,
                                    index,
                                    "display_departur_time"
                                  )
                                }
                                value={i?.display_departur_time}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <UploadFileImage
                      className="col-lg-3"
                      width={5058}
                      height={2192}
                      image={
                        packages?.package?.itineary_image
                          ? `${constants.MEDIAURL}/${packages?.package?.itineary_image}`
                          : packages?.package?.itineary_image
                      }
                      label={"English Map Image"}
                      placeholder={"Upload English Map Image "}
                      selectedFile={selectedFile}
                      setImageForPackages={setItinearyImage}
                      setSelectedFile={setSelectedFile}
                    />

                    <UploadFileImage
                      className="col-lg-3"
                      width={5058}
                      height={2192}
                      image={
                        packages?.package?.itineary_simplified_chinese_image
                          ? `${constants.MEDIAURL}/${packages?.package?.itineary_simplified_chinese_image}`
                          : packages?.package?.itineary_simplified_chinese_image
                      }
                      label={"Simplified Chinese Map Image"}
                      placeholder={"Upload Simplified Chinese Map Image "}
                      selectedFile={simplifiedChineseFile}
                      setImageForPackages={setItinearySimplifiedChineseImage}
                      setSelectedFile={setSimplifiedChineseFile}
                    />
                    <UploadFileImage
                      className="col-lg-3"
                      width={5058}
                      height={2192}
                      image={
                        packages?.package?.itineary_traditional_chinese_image
                          ? `${constants.MEDIAURL}/${packages?.package?.itineary_traditional_chinese_image}`
                          : packages?.package
                              ?.itineary_traditional_chinese_image
                      }
                      label={"Traditional Chinese Map Image "}
                      placeholder={"Upload Traditional Chinese Map Image "}
                      selectedFile={traditionalChineseFile}
                      setImageForPackages={setItinearyTraditionalChineseImage}
                      setSelectedFile={setTraditionalChineseFile}
                    />
                    <UploadFileImage
                      className="col-lg-3"
                      width={5058}
                      height={2192}
                      image={
                        packages?.package?.itineary_bahasa_image
                          ? `${constants.MEDIAURL}/${packages?.package?.itineary_bahasa_image}`
                          : packages?.package?.itineary_bahasa_image
                      }
                      label={"Bahasa Map Image"}
                      placeholder={"Upload Bahasa Map Image"}
                      selectedFile={bahasaFile}
                      setImageForPackages={setItinearyBahasaImage}
                      setSelectedFile={setBahasaFile}
                    />
                    <AltTextInput className="col-lg-3" label="English Map Image Alt Text" field="itineary_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Simplified Chinese Map Image Alt Text" field="itineary_simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Traditional Chinese Map Image Alt Text" field="itineary_traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Bahasa Map Image Alt Text" field="itineary_bahasa_image_alt" values={altText} setValues={setAltText} />

                    <UploadFileImage
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        packages?.package?.thumbnail_image
                          ? `${constants.MEDIAURL}/${packages?.package?.thumbnail_image}`
                          : packages?.package?.thumbnail_image
                      }
                      label={"English Itinerary Package Image"}
                      placeholder={"Upload English Itinerary Package Image "}
                      selectedFile={thumbailSelectedFile}
                      setImageForPackages={setThumbnailImage}
                      setSelectedFile={setThumbailSelectedFile}
                    />

                    <UploadFileImage
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        packages?.package?.thumbnail_simplified_chinese_image
                          ? `${constants.MEDIAURL}/${packages?.package?.thumbnail_simplified_chinese_image}`
                          : packages?.package
                              ?.thumbnail_simplified_chinese_image
                      }
                      label={"Simplified Chinese Itinerary Package Image"}
                      placeholder={
                        "Upload Simplified Chinese Itinerary Package Image "
                      }
                      selectedFile={thumbnailSimplifiedChineseFile}
                      setImageForPackages={setThumbnailSimplifiedChineseImage}
                      setSelectedFile={setThumbnailSimplifiedChineseFile}
                    />
                    <UploadFileImage
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        packages?.package?.thumbnail_traditional_chinese_image
                          ? `${constants.MEDIAURL}/${packages?.package?.thumbnail_traditional_chinese_image}`
                          : packages?.package
                              ?.thumbnail_traditional_chinese_image
                      }
                      label={"Traditional Chinese Itinerary Package Image "}
                      placeholder={
                        "Upload Traditional Chinese Itinerary Package Image "
                      }
                      selectedFile={thumbnailTraditionalChineseFile}
                      setImageForPackages={setThumbnailTraditionalChineseImage}
                      setSelectedFile={setThumbnailTraditionalChineseFile}
                    />
                    <UploadFileImage
                      className="col-lg-3"
                      width={778}
                      height={542}
                      image={
                        packages?.package?.thumbnail_bahasa_image
                          ? `${constants.MEDIAURL}/${packages?.package?.thumbnail_bahasa_image}`
                          : packages?.package?.thumbnail_bahasa_image
                      }
                      label={"Bahasa Itinerary Package Image"}
                      placeholder={"Upload Bahasa Itinerary Package Image"}
                      selectedFile={thumbnailBahasaFile}
                      setImageForPackages={setThumbnailBahasaImage}
                      setSelectedFile={setThumbnailBahasaFile}
                    />
                    <AltTextInput className="col-lg-3" label="English Itinerary Package Image Alt Text" field="thumbnail_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Simplified Chinese Itinerary Package Image Alt Text" field="thumbnail_simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Traditional Chinese Itinerary Package Image Alt Text" field="thumbnail_traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                    <AltTextInput className="col-lg-3" label="Bahasa Itinerary Package Image Alt Text" field="thumbnail_bahasa_image_alt" values={altText} setValues={setAltText} />
                  </div>
                </div>
              </div>
            )}

            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Note</label>
                      <ReactQuill
                        value={englishNote}
                        onChange={(e) => setEnglishNote(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Simplified Chinese Note</label>
                      <ReactQuill
                        value={simplifiedChinesNote}
                        onChange={(e) => setSimplifiedChineseNote(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Note
                      </label>
                      <ReactQuill
                        value={traditionalChineseNote}
                        onChange={(e) => setTraditionalChineseNote(e)}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Note</label>
                      <ReactQuill
                        value={bahasaNote}
                        onChange={setBahasaNote}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={(e) => setIsActive(e.target.checked)}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">Update Package</button>
              </div>
            </div>
          </form>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};
PackageInput2.propTypes = {
  packages: PropTypes.any.isRequired,
};
export default PackageInput2;
